//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminPayslipDocumentController_findAll,
  Response$AdminPayslipDocumentController_findAll$Status$200,
  ResponseContentType$AdminPayslipDocumentController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminPayslipDocumentController_findAll = (options: {
  params: Params$AdminPayslipDocumentController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminPayslipDocumentController_findAll$Status$200[ResponseContentType$AdminPayslipDocumentController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminPayslipDocumentController_findAll,
    Response$AdminPayslipDocumentController_findAll$Status$200[ResponseContentType$AdminPayslipDocumentController_findAll]
  >({
    method: 'AdminPayslipDocumentController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
